export const MINT_COMPONENT_HEADING_SUBTEXT = {
  FIXED: {
    heading: 'Fixed Edition',
  },
  OPEN: {
    heading: 'Open Edition',
  },
  SAM: {
    heading: 'Sound Swap',
  },
  FOREVER: {
    heading: 'Forever Edition',
  },
  FALLBACK: {
    heading: 'Limited Edition',
  },
} as const satisfies Record<Uppercase<string>, { heading: string }>;
